import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Banner = styled.header`
  display: block;
  background-color: #F1F3F8;
  width: 100%;
  z-index: 99;
`;

const Container = styled.div`
  min-height: 128px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.theme.isXXLarge && `
    width: 1200px;
  `};
  ${props => props.theme.isXLarge && `
    width: 953px;
  `};
  ${props => props.theme.isLarge && `
    width: 85%;
  `};
  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
  `};
  padding: ${props => (props.theme.isMobileOrTablet ? '22px 20px 26px 20px' : '0')};
`;

const Name = styled.h1`
  margin: 0;
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  text-transform: capitalize;
  line-height: 130%;
  font-size: ${props => (props.theme.isMobileOrTablet ? (32 + (props.theme.isMobile ? 0 : 2)) : 40)}px;
`;

export default function Header({ name }) {
  return (
    <Banner>
      <Container>
        <Name>{name}</Name>
      </Container>
    </Banner>
  );
}

Header.propTypes = {
  name: PropTypes.string.isRequired,
};
